import { compareDecimalStrings } from '../compareDecimalStrings';

export default function proceed(
  amount,
  reAmount,
  city,
  street1,
  stateLocale,
  zip,
  fieldOfficeRequired,
  fieldOffice,
) {
  if (!amount) {
    return;
  }

  if (!reAmount) {
    return;
  }

  if (!street1) {
    return;
  }

  if (!city) {
    return;
  }

  if (!zip) {
    return;
  }

  if (!stateLocale) {
    return;
  }
  //checks if field office selection is required from user
  if (fieldOfficeRequired) {
    if (
      !amount ||
      !reAmount ||
      !street1 ||
      !city ||
      !zip ||
      !stateLocale ||
      !fieldOffice
    ) {
      return {
        err: 'MISSING_VAL',
        proceed: false,
      };
    }

    if (!fieldOfficeRequired) {
      if (
        !amount ||
        !reAmount ||
        !street1 ||
        !city ||
        !zip ||
        !stateLocale ||
        !fieldOffice
      ) {
        return {
          err: 'MISSING_VAL',
          proceed: false,
        };
      }
    }
  }

  if (compareDecimalStrings(amount, reAmount)) {
    return {
      err: null,
      proceed: true,
    };
  } else {
    return {
      err: 'AMOUNT_MISMATCH',
      proceed: false,
    };
  }
}
